import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { darken } from '@/(routers)/boards/editor/block/blockTheme';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'millis',
    colour: darken(CATEGORIES.control.color),
    tooltip: 'ボード起動からの経過時間を返します',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('MILLIS', { fontSize: 12, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                { type: 'label', text: '起動からの経過時間 ' },
                {
                    type: 'field',
                    name: 'OP',
                    instance: () =>
                        new FieldOperatorDropdown([
                            { value: 'ms', label: 'ミリ秒', tooltip: '[1/1,000 秒]' },
                            { value: 's', label: '秒', tooltip: '[1 秒]' },
                        ]),
                },
            ],
        },
    ],
});
